import { useAtomValue } from 'jotai';
import { lazy, Suspense } from 'react';
import { clinicianSessionOfferModalOpenAtom } from '../billingAtoms';

const ClinicianSessionOfferModalImplementation = lazy(() =>
  import('./clinician-session-offer-modal-implementation').then((mod) => ({
    default: mod.ClinicianSessionOfferModalImplementation,
  }))
);

export function ClinicianSessionOfferModal() {
  const isOpen = useAtomValue(clinicianSessionOfferModalOpenAtom);

  if (!isOpen) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ClinicianSessionOfferModalImplementation />
    </Suspense>
  );
}
